
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetPtype2Off as ObiMosfetPtype2OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ptype-2-off.js';
 
 
 

 
 export const ObiMosfetPtype2Off = createComponent({
   react: React,
   tagName: 'obi-mosfet-ptype-2-off',
   elementClass: ObiMosfetPtype2OffElement,
   events: {
     
   }
  });
 
 